// extracted by mini-css-extract-plugin
export var root = "_redotech-redo-customer-portal-app-lib-portal-four-submission-components-modalless-page-layout-root";